module.exports = __webpack_public_path__ + "img/pro4.0de19bc8.png";